export default __webpack_public_path__ + "static/media/gallery154_3.43589e7e.png";